import axios from "axios";

export default function reassignNode({ payload }) {
  return new Promise((resolve, reject) =>
    axios
      .post("/distributor/system-admin/api/v1/reassign-node", {
        source_node_uuid: payload.source_node_uuid,
        target_node_uuid: payload.target_node_uuid,
        mode: payload.mode,
        from_seq_num: payload.from_seq_num,
        to_seq_num: payload.to_seq_num,
        from_sn: payload.from_sn,
        to_sn: payload.to_sn,
      })
      .then((response) => resolve(response.data))
      .catch((error) => {
        if (error.response && error.response.data) {
          const err = new Error(error.response.data.message);
          err.data = error.response.data;
          reject(err);
        }
      })
  );
}
